"use client";

import {
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@/app/components/ui/alert-dialog";
import { Button } from "@/app/components/ui/button";
import { Input } from "@/app/components/ui/input";
import { Loader2 } from 'lucide-react';
import { Text } from "@radix-ui/themes";
import React, { useState, forwardRef } from "react";
import { ClearableDialogHandle } from "@/app/(bidders)/DataTableRowActions";

interface Props {
  email: string;
  submitting: boolean;
  onClick: () => void;
}


const FlagBidderDialog = forwardRef<ClearableDialogHandle, Props>((
  { email, submitting, onClick }: Props,
  ref
) => {
  const [inputValue, setInputValue] = useState<string>("");

  React.useImperativeHandle(ref, () => ({
    clear: () => setInputValue("")
  }));

  return (
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogHeader className="font-semibold text-xl">
          Flag {email}
        </AlertDialogHeader>
        <AlertDialogDescription>
          <Text>
            By flagging this user, you are:
            <br />
            <br />
          </Text>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li>preventing them from bidding in the future,</li>
            <li>
              invalidating any of their live bids in currently running auctions,
              and{" "}
            </li>
            <li>
              triggering recomputations on the lots on which they&apos;ve bid
              (possibly lowering the current bid).
            </li>
          </ul>
          <br />
          <Text>
            Confirm only if you&apos;re absolutely sure you want to flag this
            user. <b>Any bids which are removed cannot be reinstated</b>,
            although by unflagging a user, you allow them to bid again.
            <br />
            <br />
            Type their email below to confirm.
          </Text>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <Input
        placeholder={email}
        onPaste={(e: any) => e.preventDefault()}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <Button
          disabled={inputValue !== email || submitting}
          variant="destructive"
          onClick={onClick}
        >
          {submitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Flag Bidder
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
});

FlagBidderDialog.displayName = "FlagBidderDialog";

export default FlagBidderDialog;
